export { formatBreadcrumbListSchema, formatFaqPageSchema, formatVideoSchema, formatHowToSchema, formatReviewToSchema } from "./structured-data";
